import { ReactElement } from "react";

export const Forbidden = (): ReactElement => {

    return <div>
        <h1>Zugriff verboten</h1>
        <span>Sie Haben keine Zugriffsrechte auf diesen Bereich</span>
    </div>
}